<template>
  <!--    <div class="row">-->
  <!--      <div class="col-md-12"><money-claim-form></money-claim-form></div>-->
  <!--    </div>-->
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width">
        <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <h4 class="card-title">{{ $t('accountCreditDebitLog.tableTitle') }}</h4>
        </div>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-primary mb-3 pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <div class="row">
              <div class="col-6">
                <base-input>
                  <el-input
                    type="search"
                    class="mb-3 search-input"
                    prefix-icon="el-icon-search"
                    :placeholder="$t('generic.searchInTablePlaceholder')"
                    v-model="searchQuery"
                    aria-controls="datatables"
                  >
                  </el-input>
                </base-input>
              </div>
            </div>
          </div>

          <el-table v-loading="loading" :data="queriedData" show-header :empty-text="$t('generic.noData')">
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="$t(column.label)"
              :formatter="column.formatter"
            >
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">
              {{$t('generic.tablePaginationSummary', {from: from+1, to: to, total: total})}}
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import {Option, Select, Table, TableColumn, Tooltip} from 'element-ui';
  import {BaseAlert, BaseButton, BasePagination} from 'src/components';
  import Fuse from 'fuse.js';
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'accountMoneyClaims',
    components: {
      BasePagination,
      BaseAlert,
      BaseButton,
      Tooltip,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    props: {
      accountId: {
        type: String,
        required: true
      },
    },
    computed: {
      ...mapState({
        loading: state => state.account_credit_debit_logs.loading,
      }),
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      }
    },
    data() {
      return {
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['token'],
        tableColumns: [
          {
            prop: 'id',
            label: 'generic.id',
          },
          {
            prop: 'source_id',
            label: 'accountCreditDebitLog.source_id',
          },
          {
            prop: 'type',
            label: 'accountCreditDebitLog.type',
          },
          {
            prop: 'credit_debit',
            label: 'accountCreditDebitLog.credit_debit',
            formatter: (row, column, cellValue, index) => {
              return this.$options.filters.price(cellValue)
            },
          },
          {
            prop: 'balance',
            label: 'accountCreditDebitLog.balance',
            formatter: (row, column, cellValue, index) => {
              return this.$options.filters.money(cellValue)
            },
          },
          {
            prop: 'business_day',
            label: 'generic.business_day',
            formatter: (row, column, cellValue, index) => {
              return this.$options.filters.dateOnly(cellValue)
            },
          },
          {
            prop: 'created_at',
            label: 'generic.created',
            formatter: (row, column, cellValue, index) => {
              return this.$options.filters.time(cellValue)
            },
          },
          {
            prop: 'updated_at',
            label: 'generic.updated',
            formatter: (row, column, cellValue, index) => {
              return this.$options.filters.time(cellValue)
            },
          },
        ],
        tableData: [],
        searchedData: [],
        fuseSearch: null
      };
    },
    methods: {
      ...mapActions(['LoadAccountCreditDebitLogs']),
    },
    mounted() {
      this.LoadAccountCreditDebitLogs(this.accountId);
    },
    watch: {
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = this.tableData;
        if (value !== '') {
          result = this.fuseSearch.search(this.searchQuery);
        }
        this.searchedData = result;
      },
      "$store.state.account_credit_debit_logs.data"(data) {
        this.tableData = data
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
          keys: ['token'],
          threshold: 0.3
        });
      }
    }
  };
</script>
<style>
  .pagination-select,
  .search-input {
    width: 200px;
  }
</style>
